export default {
  state: {
    sessionModal: {
      show: false,
      startTracking: false,
      isOnGoing: false,
      storedFlight: {
        leg1: {
          Economy: null,
          PremiumEconomy: null,
          Business: null,
          PremiumBusiness: null,
          First: null,
          API2: null
        },
        leg2: {
          Economy: null,
          PremiumEconomy: null,
          Business: null,
          PremiumBusiness: null,
          First: null,
          API2: null
        }
      }
    }
  },
  mutations: {
    setSessionModalData (state, data) {
      for (let field in data) {
        state.sessionModal[field] = data[field]
      }
    },
    setStoredFlightData (state, data) {
      for (let field in data.fields) {
        state.sessionModal.storedFlight[data.leg][field] = data.fields[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/session-modal.js